import classNames from "classnames";

import UtilityPageNav from "content-ui/utilityPages/components/utilityPageNav";
import ContactSection from "./components/contactSection";
import BenefitSection from "./components/benefitSection";
import WhySifted from "./components/whySifted";
import Carousel from "./components/carousel";
import Headline from "./components/headline";
import Openings from "./components/openings";

const CareersView = ({ data }) => {
  const innerContainerClasses = classNames(
    "relative flex flex-col pb-[100px] md:mx-auto lg:flex-row md:max-w-[1040px] lg:max-w-[1220px] px-5 lg:px-0"
  );

  return (
    <main
      data-page-type="careers"
      className="bg-[#F6F6F6] pt-[60px] text-[16px] leading-[130%] text-black-rock lg:pt-[109px]"
    >
      <div className={innerContainerClasses}>
        <UtilityPageNav />
        <div className="mt-[1.25rem]">
          <Headline headline={data.headline} subhead={data.subhead} />
          <Carousel slides={data.carousel} />
          <WhySifted
            heading={data.whySiftedSectionHeading}
            testimonials={data.memberTestimonials}
          />
          <BenefitSection
            heading={data.benefitSectionHeading}
            benefitList={data.benefitList}
          />
          <Openings
            heading={data.hiringSectionHeading}
            positions={data.openings}
          />
          <ContactSection data={data} />
        </div>
      </div>
    </main>
  );
};
export default CareersView;
